import { render, staticRenderFns } from "./ModelFeature.vue?vue&type=template&id=982432d8&"
import script from "./ModelFeature.vue?vue&type=script&lang=ts&"
export * from "./ModelFeature.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports